"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeaturedScreenLightDisabled = void 0;
var _react = _interopRequireDefault(require("react"));
var FeaturedScreenLightDisabled = exports.FeaturedScreenLightDisabled = function FeaturedScreenLightDisabled() {
  return _react["default"].createElement("svg", {
    width: "96",
    height: "54",
    viewBox: "0 0 96 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("rect", {
    width: "96",
    height: "54",
    fill: "#B8BBCC"
  }), _react["default"].createElement("g", {
    opacity: "0.7"
  }, _react["default"].createElement("rect", {
    x: "7",
    y: "7",
    width: "24",
    height: "12",
    rx: "2",
    fill: "#F1F1F5"
  }), _react["default"].createElement("path", {
    d: "M19 13C20.0938 13 21 12.1094 21 11C21 9.90625 20.0938 9 19 9C17.8906 9 17 9.90625 17 11C17 12.1094 17.8906 13 19 13ZM20.3906 13.5H20.125C19.7812 13.6719 19.4062 13.75 19 13.75C18.5938 13.75 18.2031 13.6719 17.8594 13.5H17.5938C16.4375 13.5 15.5 14.4531 15.5 15.6094V16.25C15.5 16.6719 15.8281 17 16.25 17H21.75C22.1562 17 22.5 16.6719 22.5 16.25V15.6094C22.5 14.4531 21.5469 13.5 20.3906 13.5Z",
    fill: "#B8BBCC"
  }), _react["default"].createElement("rect", {
    x: "7",
    y: "21",
    width: "24",
    height: "12",
    rx: "2",
    fill: "#F1F1F5"
  }), _react["default"].createElement("path", {
    d: "M19 27C20.0938 27 21 26.1094 21 25C21 23.9062 20.0938 23 19 23C17.8906 23 17 23.9062 17 25C17 26.1094 17.8906 27 19 27ZM20.3906 27.5H20.125C19.7812 27.6719 19.4062 27.75 19 27.75C18.5938 27.75 18.2031 27.6719 17.8594 27.5H17.5938C16.4375 27.5 15.5 28.4531 15.5 29.6094V30.25C15.5 30.6719 15.8281 31 16.25 31H21.75C22.1562 31 22.5 30.6719 22.5 30.25V29.6094C22.5 28.4531 21.5469 27.5 20.3906 27.5Z",
    fill: "#B8BBCC"
  }), _react["default"].createElement("rect", {
    x: "7",
    y: "35",
    width: "24",
    height: "12",
    rx: "2",
    fill: "#F1F1F5"
  }), _react["default"].createElement("path", {
    d: "M19 41C20.0938 41 21 40.1094 21 39C21 37.9062 20.0938 37 19 37C17.8906 37 17 37.9062 17 39C17 40.1094 17.8906 41 19 41ZM20.3906 41.5H20.125C19.7812 41.6719 19.4062 41.75 19 41.75C18.5938 41.75 18.2031 41.6719 17.8594 41.5H17.5938C16.4375 41.5 15.5 42.4531 15.5 43.6094V44.25C15.5 44.6719 15.8281 45 16.25 45H21.75C22.1562 45 22.5 44.6719 22.5 44.25V43.6094C22.5 42.4531 21.5469 41.5 20.3906 41.5Z",
    fill: "#B8BBCC"
  })), _react["default"].createElement("g", {
    opacity: "0.7"
  }, _react["default"].createElement("rect", {
    x: "33",
    y: "7",
    width: "56",
    height: "40",
    rx: "2",
    fill: "#F1F1F5"
  }), _react["default"].createElement("path", {
    d: "M67.375 21.5H54.625C53.9922 21.5 53.5 22.0156 53.5 22.625V30.125C53.5 30.7578 53.9922 31.25 54.625 31.25H60.25V32H56.125C55.9141 32 55.75 32.1875 55.75 32.375V33.125C55.75 33.3359 55.9141 33.5 56.125 33.5H65.875C66.0625 33.5 66.25 33.3359 66.25 33.125V32.375C66.25 32.1875 66.0625 32 65.875 32H61.75V31.25H67.375C67.9844 31.25 68.5 30.7578 68.5 30.125V22.625C68.5 22.0156 67.9844 21.5 67.375 21.5ZM67 29.75H55V23H67V29.75Z",
    fill: "#B8BBCC"
  })));
};